import React from 'react';
import { FiGrid } from 'react-icons/fi';
import { useAirflowDashboard } from './use-airflow-dashboard';
import { DagsTab } from './dags-tab';
import { ImportErrorsBanner } from './import-errors-banner';
import { UtcClock } from './utc-clock';
import styles from './styles.module.scss';
import './theme-overrides.scss';

/*
 * Top-level Airflow Dashboard screen — DAGs list, gated behind the disable-Airflow feature flag
 */
export function AirflowDashboardScreen() {
    const { isAirflowDisabled } = useAirflowDashboard();

    if (isAirflowDisabled) {
        return (
            <div className={`${styles.page} airflowDashboardRoot`}>
                <div className={styles.disabledBox}>
                    <h2>
                        Airflow is not deployed on this environment
                        <br />
                        Contact DeepIQ
                    </h2>
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.page} airflowDashboardRoot`}>
            <div className={styles.headerRow}>
                <h1>
                    <FiGrid /> Job Dashboard
                </h1>
                <UtcClock />
            </div>
            <ImportErrorsBanner />
            <DagsTab />
        </div>
    );
}
